var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.778 3.526c-.15.082-5.785 5.38-5.927 5.573-.494.672-.448 1.642.105 2.239.255.275 5.747 5.071 5.886 5.14.175.087.327.053.491-.111a.779.779 0 0 0 .172-.269c.038-.128.035-.151-.04-.286-.062-.111-.775-.753-2.935-2.643-2.551-2.231-2.864-2.515-2.942-2.672-.145-.291-.101-.605.12-.862.06-.07 1.226-1.173 2.592-2.452 2.941-2.754 3.093-2.9 3.154-3.043.086-.196-.015-.414-.27-.588-.146-.099-.258-.106-.406-.026",
    fillRule: "evenodd",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiArrowLeft);
export default __webpack_public_path__ + "static/media/fi-arrow-left.3fd39865e5e8efb03e29347eb6fdcd1f.svg";
export { ForwardRef as ReactComponent };